export default "__VITE_ASSET__CiZhxjfQ__"